import React, { memo } from "react";
import { TrackOccupation } from "@opstel/query/models/trackOccupation";
import { TIMELINE_DEFAULT_HOUR_WIDTH } from "../../core/layoutConstants";
import { StickyInfoText } from "./StickyInfoText";
import { getTrackOccupationPosition } from "@opstel/SBD/core/functions";
import { useSelectedTimeStore } from "@shared/common/contexts/SelectedTime/useSelectedTimeStore";

interface SBDOccupationProps {
  readonly children?: React.ReactNode;
  readonly occupation: TrackOccupation;
  readonly zoomLevel: number;
  readonly showStickyText: boolean;
}

export function SBDOccupation({
  children,
  occupation,
  zoomLevel,
  showStickyText,
}: SBDOccupationProps) {
  const scenarioStart = useSelectedTimeStore((state) => state.scenarioInterval?.start)!;

  const startTimeInHours = occupation.startTime.diff(scenarioStart).as("hours");
  const durationInHours = occupation.endTime.diff(occupation.startTime).as("hours");

  const left = startTimeInHours * TIMELINE_DEFAULT_HOUR_WIDTH * zoomLevel;
  const width = durationInHours * TIMELINE_DEFAULT_HOUR_WIDTH * zoomLevel;
  const top = getTrackOccupationPosition(occupation.order);

  return (
    <>
      {children}
      {showStickyText && (
        <>
          {(occupation.trackGroupDrawDirection === "None" ||
            occupation.trackGroupDrawDirection === "Down") && (
            <StickyInfoTextMemo
              key="arrive"
              type="arrive"
              left={left}
              top={top}
              width={width}
              trainNumber={occupation.arrivesAs}
              units={TrackOccupation.trainUnitsInDrivingDirectionAtBegin(occupation)
                .map((ptu) => ptu.units)
                .join("")}
            />
          )}
          {(occupation.trackGroupDrawDirection === "None" ||
            occupation.trackGroupDrawDirection === "Up") && (
            <StickyInfoTextMemo
              key="depart"
              type="depart"
              left={left}
              top={top}
              width={width}
              trainNumber={occupation.departsAs}
              units={TrackOccupation.trainUnitsInDrivingDirectionAtEnd(occupation)
                .map((ptu) => ptu.units)
                .join("")}
            />
          )}
        </>
      )}
    </>
  );
}

const StickyInfoTextMemo = memo(StickyInfoText);
